import { DateTime } from '@guiker/date'

export const isAge18 = (birthDate: string) => {
  const maxDate = DateTime.local().minus({ years: 18 })
  const birthdate = DateTime.fromISO(birthDate)
  return birthdate <= maxDate
}
